import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { API } from "../api/api";

const useCheckActivateUser = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search)

  const [successActivate, setSuccessActivate] = useState({
    isLoading: false,
    isSuccess: false,
    msg: ''
  })

  const handleActivation = async () => {
    try {
      const res = await axios.post(API.activation, {
        token: searchParams.get('token'),
        email: searchParams.get('email'),
      })

      if (res.status !== 200) {
        throw res;
      }

      setSuccessActivate(prev => ({
        ...prev,
        isSuccess: true,
      }))

      return res.data
    } catch (error) {
      setSuccessActivate(prev => ({
        ...prev,
        isSuccess: false,
        msg: error
      }))

      return error
    }
  }

  useEffect(() => {
    handleActivation().finally(() => {
      setSuccessActivate(prev => ({
        ...prev,
        isLoading: false,
      }))
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isSuccess: successActivate.isSuccess,
    isLoading: successActivate.isLoading,
    msg: successActivate.msg,
  }
}

export default useCheckActivateUser;